import { useEffect, useState } from "react";
import Layout from "../../layouts/default";
import Classes from "./style.module.css"
import { Row, Col, Stack, Button } from "react-bootstrap"
import { useParams, useNavigate } from "react-router-dom";
import ProgressBar from "../../components/Campaigns/ProgressBar";
import CampaignFooter from "../../components/Campaigns/CampaignFooter"
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import DatePicker from "react-datepicker"
import { createCampaign, updateCampaign, loadCampaign } from "../../store/slices/campaigns/createCampaign";
import TimePicker from "../../components/Campaigns/TimePicker"
import { format } from "date-fns"
import { getQueryPlaceHolders, isValidEmail } from "../../services/utils"
import {
    loadCampaignRecurrence
} from "../../store/slices/campaigns/createCampaignRecurrence";
import { getChannels } from "../../store/slices/channels/channels";
import CampaignTagsSelector from "../../components/CampaignTags/Selector"
import CampaignNewTag from "../../components/CampaignTags/NewTag";
import ModalDialog from "../../components/UI/ModalDialog";
import { getAudienceSelectedKeys } from "../../services/audiences";


const SetCampaignName = (props) => {
    console.log("propssss : ", props)
    const [isNameValid, setIsNameValid] = useState(true)
    const [isValidStartDate, setIsValidStartDate] = useState(true)
    const [isValidStartTime, setIsValidStartTime] = useState(true)
    const [isChannelValid, setIsChannelValid] = useState(true)
    const { campaign, updateCampData } = useSelector((state) => state.createCampaignSlice);
    const { campaignRecurrence } = useSelector((state) => state.createCampaignRecurrenceSlice);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const params = useParams()
    const [scheduledDateTime, setScheduledDateTime] = useState('')
    const [startTime, setStartTime] = useState('')
    const [name, setName] = useState('');
    const [isRepeat, setIsRepeat] = useState(false);
    const [smsSenderId, setSmsSenderId] = useState('');
    const [emailFrom, setEmailFrom] = useState('');
    const [isEmailFromValid, setIsEmailFromValid] = useState(true);
    const [isSmsSenderIdValid, setIsSmsSenderIdValid] = useState(true);
    const [isRedirect, setIsRedirect] = useState(false);
    const { channels } = useSelector((state) => state.channelsSlice);
    const [openTagForm, setOpenTagForm] = useState(false)
    const [tags, setTags] = useState([])
    const [placeholderArr, setplaceholderArr] = useState([]);


    let campaignSchema = Yup.object().shape({
        name: Yup.string().required('Name is required.'),
        channel: Yup.number().required('Channel is required.'),
        startTime: Yup.string().required("Campaign start time is required"),
        scheduledDateTime: Yup.date().required('Scheduled date time is required'),
    });

    const user = JSON.parse(localStorage.getItem("user"));
    console.log("user Id is", user);
    useEffect(() => {
        let campaignId = params.id
        if (campaignId) {
            dispatch(loadCampaign(campaignId))
        }
    }, [params.id, dispatch])

    useEffect(() => {
        console.log('campaign data loading....error status', isRedirect)
        if ((campaign?.data?.id > 0) && isRedirect) {
            navigate('/campaigns/edit/audience/' + campaign?.data?.id)
        }

        if (!isRedirect) {
            console.log('isRepeat testing.....', campaign)
            if (campaign?.data.scheduledDateTime) {
                setScheduledDateTime(new Date(campaign?.data.scheduledDateTime))
            }

            if (campaign?.data.name) {
                setName(campaign?.data.name)
            }

            if (campaign?.data.isRepeat) {
                setIsRepeat(campaign?.data.isRepeat)
                console.log('isRepeat default value on load.... ', campaign?.data.isRepeat)
            }

            if (campaign?.data.smsSenderId) {
                setSmsSenderId(campaign?.data.smsSenderId)
            }

            if (campaign?.data.emailFrom) {
                setEmailFrom(campaign?.data.emailFrom)

            }

            if (campaign?.data?.campaignTags.length > 0) {
                let optionsList = []
                campaign?.data?.campaignTags.map((tag) => {
                    optionsList.push({ label: tag.name, value: tag.id })
                    return ''
                })
                console.log('saved tags okkkkkkkkkkkkkkkkkk ', optionsList)
                setTags(optionsList)
            }

        }

    }, [campaign, isRedirect, navigate, dispatch])

    const startTimeChangeHanfler = (startTimeVal) => {
        try {
            if (startTimeVal) {
                setIsValidStartTime(true)
            } else {
                setIsValidStartTime(false)
            }

        } catch (error) {

        }
    }

    useEffect(() => {
        let campaignId = params.id
        if (campaignId) {
            dispatch(loadCampaignRecurrence(campaignId))
        }

    }, [params.id])

    useEffect(() => {
        if (!channels?.data.length) {
            dispatch(getChannels())
        }
    }, [channels, dispatch])

    const __getChannelId = () => {
        let campaignId = params.id
        let channelName = updateCampData?.channel ? updateCampData?.channel : ''
        if (campaignId) {
            channelName = campaign?.data?.channel?.id ? campaign?.data.channel.id : ''
        }
        console.log('selected channel', channelName)
        return channelName
    }
    const submitHandler = async () => {
        try {

            let campaignId = params.id
            let scheduleDate = ''
            let fullDateTime = ''
            let channelName = __getChannelId()
            setIsNameValid(true)
            setIsValidStartDate(true)
            setIsValidStartTime(true)
            let scheduledDate = scheduledDateTime ? scheduledDateTime : ''

            if (scheduledDate) {

                if (startTime && startTime.indexOf(':') > 0) {

                    scheduleDate = format(new Date(scheduledDate), 'yyyy-MM-dd')
                    fullDateTime = scheduleDate + ' ' + startTime + ':00'
                } else {
                    setIsValidStartTime(false)
                }

            } else {
                setIsValidStartDate(false)
            }

            if (!name) {
                setIsNameValid(false)
            }

            if (!startTime) {
                setIsValidStartTime(false)
            }

            if (channelName === 1 && !emailFrom) {
                console.log('isEmailFromValid not valid....', isEmailFromValid)
                setIsEmailFromValid(false)
                return
            }
            if (channelName === 2 && !smsSenderId) {
                console.log('setIsSmsSenderIdValid not valid....', isSmsSenderIdValid)
                setIsSmsSenderIdValid(false)
                return
            }

            let optionsIds = []
            if (tags.length > 0) {
                optionsIds = tags.map((tag) => tag.value)
            }

            let isRepeatBool = isRepeat ? 1 : 0;
            let payload = {
                name: name,
                isRepeat: isRepeatBool,
                scheduledDateTime: fullDateTime,
                channel: channelName,
                smsSenderId: smsSenderId,
                emailFrom: emailFrom,
                campaignTags: optionsIds,
                updatedBy: user?.data?.id,
                createdBy: user?.data?.id
            }
            let checkPayload = { ...payload, startTime, }
            console.log('campaign edit.....payload', checkPayload)
            if (!checkPayload.channel) {
                setIsChannelValid(false)
                setTimeout(() => {
                    navigate('/campaigns/new')
                }, 2000)
            }
            campaignSchema
                .validate(checkPayload).then(() => {

                    if (campaignId) {
                        payload.id = campaignId
                        dispatch(updateCampaign(payload))
                        setIsRedirect(true)
                    } else {
                        dispatch(createCampaign(payload))
                        setIsRedirect(true)
                        console.log('new entry done and redirect set')
                    }

                })
                .catch(function (err) {
                    console.log('Wrong data for submission....', checkPayload, err)
                    return
                });


        } catch (error) {
            console.log('Error:', error)
        }
    }

    const __emailFromValidate = (event) => {
        try {
            if (!isValidEmail(event.target.value)) {
                setIsEmailFromValid(false)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const mondalCloseHandler = (status) => {
        setOpenTagForm(status)
    }

    const tagChangeHandler = (selectedOption) => {
        console.log('Selected option tagChangeHandler ', selectedOption)
        setTags(selectedOption)
    }


    const getPlaceholderData = async () => {
        let placeholder;
        console.log("get placeholder component sql - ", campaign);
        if (
            campaign?.data?.audience?.hasGuestAudience === "creditq" &&
            campaign?.data?.dataSource !== "FUNCTION"
        ) {
            placeholder = getQueryPlaceHolders(campaign?.data?.audience?.sqlQuery);
        } else if (campaign?.data?.dataSource === "FUNCTION") {
            placeholder = campaign?.data?.campaignFunction?.queryVars?.data;
        } else {
            let audienceId = campaign?.data?.audience?.id;

            let audienceData = await getAudienceSelectedKeys(audienceId);

            if (audienceData.audienceQueryVar[0].selectKeys.data.length) {
                let queryVars = audienceData.audienceQueryVar[0].selectKeys.data
                    ? audienceData.audienceQueryVar[0].selectKeys.data
                    : [];
                console.log("queryVars#####", queryVars);
                placeholder = queryVars;
            }
        }

        console.log("placeholder ##### - ", placeholder);
        setplaceholderArr(placeholder);
    };

    useEffect(() => {
        if (campaign?.data?.audience) {
            getPlaceholderData();
        }
    }, [campaign?.data?.audience]);

    const _copyselection = (elmId) => {
        // Get the text field
        let r = document.createRange();
        r.selectNode(document.getElementById(elmId));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(r);
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
    };

    const _getPlaceHolderFromAudienceQuery = () => {
        try {
            console.log("placeholderArr####@@@@@", placeholderArr);
            if (!placeholderArr.length) return;
            return placeholderArr.map((item) => {
                let asExist = item.indexOf("as");
                let fieldName = "";
                if (asExist > 0) {
                    fieldName = item.split("as")[1].trim();
                } else {
                    fieldName = item.trim();
                }
                return (
                    <span key={fieldName} className="inline-block px-2">
                        <span id={fieldName}>{`{{${fieldName}}}`}</span>{" "}
                        <svg
                            onClick={() => _copyselection(fieldName)}
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-clipboard"
                            viewBox="0 0 16 16"
                        >
                            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z" />
                            <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z" />
                        </svg>
                    </span>
                );
            });
        } catch (error) {
            console.log("error#####", error);
        }
    };


    useEffect(() => {

        const placeholders = _getPlaceHolderFromAudienceQuery();
        console.log("placeholders : ", placeholders);

    }, []);

    return (
        <form>
            <Layout>
                <Row>
                    <Col md={8}>
                        <div className="pageHeader mb-6">
                            <h3 className="smallHeading mb-3">Create Campaign</h3>
                            <h1>Name your Campaign</h1>

                        </div>
                        <div className="progressSteps mt-5 mb-5">
                            <input className="form-control"
                                type="text"
                                name="name"
                                onChange={(e) => {
                                    setName(e.currentTarget.value)
                                    if (e.currentTarget.value) {
                                        setIsNameValid(true)
                                    } else {
                                        setIsNameValid(false)
                                    }
                                }
                                }

                                value={name}

                            />
                            {!isNameValid && <p className="text-danger">Please enter Campaign name.</p>}
                        </div>
                        {
                            campaign?.data?.channel?.name === 'ivr' ? <div className="progressSteps"></div> : <div className="progressSteps">

                                <Stack direction="horizontal" gap={3}>
                                    <div className="" style={{ width: "72%" }}><CampaignTagsSelector
                                        onTagChange={tagChangeHandler}
                                        selectedTags={tags}
                                        multiOption={true}
                                        showLabel={true}
                                    /></div>
                                    <div className="pt-4">Or</div> <Button onClick={() => setOpenTagForm(!openTagForm)} variant="outline-secondary" className="mt-md-4"> Create new tag</Button>
                                </Stack>

                            </div>
                        }
                        <div className="progressSteps mt-5 mb-5">
                            <div className="row">
                                <div className="col">
                                    <label>Start date</label>
                                    <DatePicker
                                        selected={scheduledDateTime}
                                        dateFormat="yyyy-MM-d"
                                        className="form-control"
                                        minDate={new Date()}
                                        name="startDate"
                                        onChange={(date) => {
                                            console.log('New selected date - ', date)
                                            setScheduledDateTime(date)
                                            if (date) {
                                                setIsValidStartDate(true)
                                            }

                                        }}
                                    />
                                    <div className="py-3">{!isValidStartDate && <p className="text-danger">Please select campaign Schedule date.</p>}</div>
                                </div>
                                <div className="col">
                                    <label>Start time</label>
                                    <TimePicker
                                        setStartTime={setStartTime}
                                        startTime={startTime}
                                        onStartTimeChange={startTimeChangeHanfler}
                                    />
                                    <div className="py-3">{!isValidStartTime && <p className="text-danger">Please select campaign Schedule Start time.</p>}</div>
                                </div>
                            </div>

                        </div>
                        <Row>
                            <Col md={7}>

                                {__getChannelId() === 1 && (
                                    <div className="progressSteps mt-1 mb-5">
                                        <label>Email From</label>

                                        <input
                                            className="form-control"
                                            type="text"
                                            name="emailFrom"
                                            placeholder='Example: {{supplier_trade_name}} via CreditQ <no-reply@creditq.in>'
                                            onBlur={(event) => __emailFromValidate(event)}
                                            onChange={(e) => {
                                                setEmailFrom(e.currentTarget.value);
                                                if (e.currentTarget.value.trim()) {
                                                    setIsEmailFromValid(true);
                                                } else {
                                                    setIsEmailFromValid(false);
                                                }
                                            }}
                                            value={emailFrom}
                                        />

                                        {/* {!isEmailFromValid && (
                                            <p className="text-danger">Please enter Email From.</p>
                                        )} */}

                                        {placeholderArr.length > 0 && (
                                            <div
                                                className="mt-3 p-3 border rounded bg-light"
                                                style={{ fontSize: "14px" }}
                                            >
                                                <strong>Available Variables:</strong>

                                                <div className="mt-2 d-flex flex-wrap gap-2">
                                                    {placeholderArr.map((item) => {
                                                        const fieldName = item.includes("as")
                                                            ? item.split("as")[1].trim()
                                                            : item.trim();

                                                        const variable = `{{${fieldName}}}`;

                                                        return (
                                                            <div
                                                                key={fieldName}
                                                                className="px-2 py-1 border rounded bg-white d-flex align-items-center"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(variable);
                                                                }}
                                                            >
                                                                <span>{variable}</span>
                                                                <span className="ms-2 text-muted">📋</span>
                                                            </div>
                                                        );
                                                    })}
                                                    <div
                                                        className="px-2 py-1 border rounded bg-white d-flex align-items-center"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() =>
                                                            navigator.clipboard.writeText("{{supplier_trade_name}}")
                                                        }
                                                    >
                                                        <span className="ms-2 text-muted">📋</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                {__getChannelId() === 2 && <div className="progressSteps mt-1 mb-5">
                                    <label>SMS Sender Id</label>
                                    <input className="form-control"
                                        type="text"
                                        name="smsSenderId"
                                        onChange={(e) => {
                                            setSmsSenderId(e.currentTarget.value)
                                            if (e.currentTarget.value.trim()) {
                                                setIsSmsSenderIdValid(true)
                                            } else {
                                                setIsSmsSenderIdValid(false)
                                            }
                                        }
                                        }

                                        value={smsSenderId}

                                    />
                                    {!isSmsSenderIdValid && <p className="text-danger">Please enter sms sender Id.</p>}
                                </div>}
                            </Col>
                            <Col md={__getChannelId() === 4 ? 12 : 5}>
                                <div className={__getChannelId() === 4 ? "mb-5" : "mt-5 mb-5"}>
                                    <input type="checkbox"
                                        name="isRepeat"
                                        id="isRepeat"
                                        onChange={(e) => {
                                            setIsRepeat(e.currentTarget.checked)
                                            console.log('Repeat changed - ', e.currentTarget.checked)
                                        }}
                                        checked={isRepeat}

                                    />

                                    <label htmlFor="isRepeat">Repeat this?</label>
                                </div>
                            </Col>
                        </Row>

                        {!isChannelValid && <div className="text-danger pb-3">Channel is missing. You are redirection to Channel...</div>}
                        <CampaignFooter
                            nextStep="Select audience"
                            buttonTitle="Create Campaign" onNextStepHandler={submitHandler}
                        />
                        <ModalDialog
                            isShow={openTagForm}
                            setIsShow={openTagForm}
                            onClose={mondalCloseHandler}
                            title="Add New Tag"
                        >
                            <CampaignNewTag />
                        </ModalDialog>

                    </Col>
                    <Col md={4} className={Classes.sidebarBackground}>
                        <div className={Classes.sidebarBackground} style={{ height: '100VH' }}>
                            <ProgressBar
                                campaign={campaign}
                                updateCampData={updateCampData}
                                campaignRecurrence={campaignRecurrence}
                                allchannels={channels} />
                        </div>

                    </Col>
                </Row>

            </Layout>
        </form>
    )
}

export default SetCampaignName;